var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "modal custom submit-popup",
        attrs: { id: "basic_delete", role: "dialog" },
      },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(0),
            _vm._m(1),
            _c(
              "div",
              { staticClass: "modal-footer", staticStyle: { clear: "both" } },
              [
                _vm._m(2),
                _c("div", { staticClass: "col-xs-6 pr-0" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block emergo-green-button",
                      attrs: {
                        type: "button",
                        "data-dismiss": "modal",
                        "data-target": "#basic_delete",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("deleteConfirmation")
                        },
                      },
                    },
                    [_vm._v(" Submit ")]
                  ),
                ]),
              ]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header generic-header" }, [
      _c("img", {
        staticClass: "close-icon cursor-pointer",
        attrs: {
          src: "/static/images/icons/close_icon.svg",
          "data-dismiss": "modal",
          "data-target": "#basic_delete",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-body center pt-0" }, [
      _c("img", {
        staticClass: "info-icon",
        attrs: { src: "/static/images/icons/expiring_yellow.svg" },
      }),
      _c("div", { staticClass: "sub-header" }, [
        _vm._v(" Are you sure you want to delete the selected user(s)? "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-6 pl-0" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-block emergo-white-button",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "data-target": "#basic_delete",
          },
        },
        [_vm._v(" Cancel ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }